/**
 * Copyright © Veeam Software Group GmbH.
 */

import { DayOfWeek as DayOfWeekModel } from '@veeam-vspc/models/web-controllers';

export type DayOfWeek = DayOfWeekModel;
export const DayOfWeek = DayOfWeekModel;
